import './index.scss'
import '../../assets/scripts/jquery.select.js'
$('select').select();